import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import Breadcrumb from "../../components/Breadcrumb";
import MainLayout from "../../components/MainLayout";
import ProtectedPermissionPage from "../../components/ProtectedPermissionPage";
import OpnameDashboardSection from "./OpnameDashboardSection";
import OpnameManage from "./OpnameManage";
import OpnameStation from "./OpnameStation";

type OpnameTab = "station" | "dashboard" | "manage";

export default function OpnameDashboard() {
  const [currentTab, setCurrentTab] = useState<OpnameTab>("station");

  const handleTabChange = (event: React.SyntheticEvent, newValue: OpnameTab) => {
    setCurrentTab(newValue);
  };

  const renderContent = () => {
    switch (currentTab) {
      case "station":
        return <OpnameStation />;
      case "dashboard":
        return <OpnameDashboardSection />;
      case "manage":
        return <OpnameManage />;
      default:
        return null;
    }
  };

  return (
    <ProtectedPermissionPage acceptPermissions={[1, 2, 3, 13]}>
      <Helmet>
        <title>Stock Opname - Dashboard</title>
      </Helmet>
      <MainLayout>
        <Breadcrumb
          breadcrumbs={[
            { label: "Dashboard", href: "/app/dashboard" },
            { label: "Stock Opname" },
          ]}
          label="Stock Opname"
        />
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="Station" value="station" />
            <Tab label="Dashboard" value="dashboard" />
            <Tab label="Manage" value="manage" />
          </Tabs>
        </Box>
        {renderContent()}
      </MainLayout>
    </ProtectedPermissionPage>
  );
}
